
import React  ,{useState} from 'react'

export function GameImg( {props,valor} ) {
  const ifContidion = { display: "none" };
  const elseCondition = { display: "grid" };
  const [ book, setBook ] = useState("1");
  const [ itBook, setItBook ] = useState(ifContidion);
      function heandlerBook(){
    if ( book === "1" ) {
      setBook("2");
      setItBook(elseCondition);
        
    } else {
      setBook("1");
      setItBook(ifContidion);
    }
  }
  return (
    <>
    <div style={{marginBottom:"2.5%"}}><button className='slashButton' onClick={()=> { heandlerBook(); }}>Ver Imagenes del Juego</button></div>
        <div className='containerBlockImg' style={itBook}>
            <div className='body_figure' >
            {props.map((e,index)=> (
                <figure key={index}>
                    <img src={`GameImg/${e}`} alt="Imagen" />
                    <figcaption >{valor[index]}</figcaption>
                </figure>
            ))}
        </div>
    </div>
    </>
  )
}
